import React, { useContext, useEffect, useState } from "react";

import estilo from "../styles/Catalogo.module.css";
import supabase from "../config/supabaseClient";
import Paginacion from "../components/Paginacion";
import Tarjetas from "../components/Tarjetas";

import { DataContext } from "../context/DataContext";
import MetaDecorator from "../utils/MetaDecorator";

function Catalogo() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { data, cambio } = useContext(DataContext);

  const [traer, setTraer] = useState(cambio);
  const [genero, setGenero] = useState(data);
  const [anime, setAnime] = useState([]);

  function todos() {
    setTraer(true);
    setGenero("");
  }

  function cambiar(e) {
    setTraer(false);
    setGenero(e.target.value);
  }

  let generos = [
    "Acción",
    "Aventura",
    "Colegial",
    "Comedia",
    "Deportes",
    "Ecchi",
    "Fantasía",
    "Harem",
    "Isekai",
    "Magia",
    "Militar",
    "Romance",
    "Shounen",
    "Sobrenatural",
    "Vampiros",
  ];

  console.log(generos.sort());

  useEffect(() => {
    const fetchAnime = async () => {
      if (traer) {
        const { data, error } = await supabase.from("anime").select();
        if (error) {
          setAnime(null);
        }
        if (data) {
          setAnime(data);
        }
      } else {
        const { data, error } = await supabase
          .from("anime")
          .select()
          .contains("generos", JSON.stringify([{ genero: genero }]));
        if (error) {
          setAnime(null);
        }
        if (data) {
          setAnime(data);
        }
      }
    };

    fetchAnime();
  }, [genero, traer]);

  const [paginaActual, setPaginaActual] = useState(1);
  const [cantidadPorPagina] = useState(12);

  const ultimaPosicionI = paginaActual * cantidadPorPagina;
  const primeraPosicionI = ultimaPosicionI - cantidadPorPagina;
  const posicionesActuales = anime.slice(primeraPosicionI, ultimaPosicionI);

  return (
    <div className={estilo.contenedor_catalogo}>
      {anime && (
        <MetaDecorator
          titulo={"Animes Online Sub Español Gratis | yTAnimeTV"}
          subtitulo={"ytanimetv.com"}
          descripcion={
            "Todos los animes disponibles en la mejor pagina para Ver Anime Online en subtitulados al Español, mira los ultimos capitulos de los animes actuales totalmente gratis."
          }
          keywords={
            "anime online español, anime online gratis, anime online naruto, anime online naruto shippuden, anime online sub español, anime online free, anime online latino, anime online bleach, animes, anime, ecchi, anime online, Naruto Shippuden, Anime online, Anime en Descarga Directa, Ver Anime Online." +
            " " +
            generos.map((e) => e).join(", ")
          }
          url={"https://ytanimetv.com/animes"}
          canonical={"https://ytanimetv.com/animes"}
        />
      )}
      <div className={estilo.filtro}>
        <button onClick={todos} className={traer ? `${estilo.activo}` : ""}>
          Todos
        </button>

        {generos.sort().map((e, i) => (
          <button
            key={i}
            onClick={cambiar}
            value={e}
            className={genero === e ? `${estilo.activo}` : ""}
          >
            {e}
          </button>
        ))}
      </div>

      {anime && (
        <div className={estilo.tarjetas_grid}>
          {posicionesActuales.map((e) => (
            <Tarjetas key={e.id} lista={e}></Tarjetas>
          ))}
        </div>
      )}
      <Paginacion
        posicionesTotales={anime.length}
        cantidadPorPagina={cantidadPorPagina}
        setPaginaActual={setPaginaActual}
        paginaActual={paginaActual}
      ></Paginacion>
    </div>
  );
}

export default Catalogo;
